import { useValidation } from '@xengage/gw-portals-validation-react';
import { AddressStandardizationServiceCC } from 'twia-capability-fnol-addressstandardization';
import { TWIAAddressComponent } from 'twia-capability-address-component';
import { useAuthentication } from '@xengage/gw-digital-auth-react';
import { ViewModelForm, ViewModelServiceContext } from '@xengage/gw-portals-viewmodel-react';
import _ from 'lodash';
import React, { useCallback, useEffect, useState, useContext } from 'react';
import appConfig from 'app-config';
import Address from '../../models/Address';
import metadata from './PropertyDamageForm.metadata.json5';
import styles from './PropertyDamageForm.module.scss';

const fillAddress = (addressVM, propDamageVM, isEditPropDamageForm) => {
    if (isEditPropDamageForm && _.get(propDamageVM.value, 'isAddressRequired')) {
        _.set(addressVM, 'value',
            _.get(propDamageVM, 'fixPropIncidentContact.primaryAddress.value')
        );
        return addressVM;
    }
    return addressVM;
}

const fillAddressPropLoc = (addressVM, propDamageVM, isEditPropDamageForm) => {
    if (isEditPropDamageForm && _.get(propDamageVM.value, 'isLiabLocRequired')) {
        _.set(addressVM, 'value',
            _.get(propDamageVM, 'liabPropDamageLocation.value')
        );
        return addressVM;
    }
    return addressVM;
}

const PropertyDamageForm = props => {
    const viewModelService = useContext(ViewModelServiceContext);
    const {
        propertyDamageVM,
        claimVM,
        updateWizardData,
        setEditPropDamageForm,
        isEditPropDamageForm,
        setShowPropDamageForm,
        onValidate
    } = props;
    const {
        isComponentValid,
    } = useValidation('PropertyDamageForm');
    const primaryAddressVM = viewModelService.create(
        new Address(),
        'cc',
        'edge.capabilities.address.dto.AddressDTO'
    );
    const propLocAddressVM = viewModelService.create(
        new Address(),
        'cc',
        'edge.capabilities.address.dto.AddressDTO'
    );
    const { authHeader } = useAuthentication();
    const [incidentVM, updateIncidentVM] = useState(propertyDamageVM);
    const [addressVM, setAddressVM] = useState(fillAddress(primaryAddressVM, propertyDamageVM, isEditPropDamageForm));
    const [addressPropLocVM, setAddressPropLocVM] = useState(fillAddressPropLoc(propLocAddressVM, propertyDamageVM, isEditPropDamageForm));
    const [ccConstants, setCCConstants] = useState([]);
    const [isStandardizationDisabled, setIsStandardizationDisabled] = useState(false);
    const [isButtonDisabled, updateDisablity] = useState(false);
    const [invalidComponent, setInvalidComponents] = useState([]);
    const [ isAddressEdited, setIsAddressEdited ] = useState(false);
    const [isStandardizationDisabledPropLoc, setIsStandardizationDisabledPropLoc] = useState(false);
    const [isButtonDisabledPropLoc, updateDisablityPropLoc] = useState(false);
    const [invalidComponentPropLoc, setInvalidComponentsPropLoc] = useState([]);
    const [ isAddressEditedPropLoc, setIsAddressEditedPropLoc ] = useState(false);
    const country = _.get(primaryAddressVM, 'country.value.code');
    const countryPropLoc = _.get(propLocAddressVM, 'country.value.code');
    const xPortal = 'CC';
    const [showErrors, setShowErrors] = useState(false);
    const [showAddress, setShowAddress] = useState(false);
    const [showAddressDamagedProp, setShowAddressDamagedProp] = useState(false);
    const isCEAM = appConfig.applicationDetails.applicationName === 'CustomerEngage Account Management'

    const getCCConstants = useCallback(async () => {
        const constants = await AddressStandardizationServiceCC.getCCPortalConstants(authHeader);
        if (!constants.portalAddressStandardizationEnabled) {
            setIsStandardizationDisabled(true);
            setIsStandardizationDisabledPropLoc(true);
            updateDisablity(true);
            updateDisablityPropLoc(true);
        }
        setCCConstants(constants);
    }, []);

    useEffect(() => {
        getCCConstants();
        if(_.isUndefined(_.get(addressVM, 'mustStandardize_Ext.value'))){
            _.set(addressVM, 'mustStandardize_Ext.value', true);
            _.set(addressVM, 'addressVerifyStatusExt.value', 'notvalidated');
            setAddressVM(addressVM);
        }
    }, [addressVM]);

    const findInvalidComponent = useCallback((isValid, componentID) => {
        if (isValid === false) {
            setInvalidComponents((oldValue) => [...oldValue, componentID]);
        }

        if (isValid === true) {
            setInvalidComponents((oldValue) => oldValue.filter((val) => val !== componentID));
        }
    }, []);

    const findInvalidComponentPropLoc = useCallback((isValid, componentID) => {
        if (isValid === false) {
            setInvalidComponentsPropLoc((oldValue) => [...oldValue, componentID]);
        }

        if (isValid === true) {
            setInvalidComponentsPropLoc((oldValue) => oldValue.filter((val) => val !== componentID));
        }
    }, []);

    const setDisablity = useCallback((value) => {
        if (!isStandardizationDisabled) {
            updateDisablity(false);
        }
        else {
            updateDisablity(addressControl.isStdBtnAvailable(value, xPortal))
        }
    }, [updateDisablity]);

    const setDisablityPropLoc = useCallback((value) => {
        if (!isStandardizationDisabled) {
            updateDisablity(false);
        }
        else {
            updateDisablity(addressControl.isStdBtnAvailable(value, xPortal))
        }
    }, [updateDisablity]);

    const updatePolicyAddressVM = useCallback((addrssVM) => {
        if (addrssVM) {
            //setAddressVM(addrssVM);
            _.set(incidentVM.value, 'fixPropIncidentContact.primaryAddress', addrssVM.value ? addrssVM.value : addrssVM);
            setDisablity(addrssVM);
            if(addrssVM?.addressVerifyStatusExt === 'validated') {
                _.set(incidentVM, 'fixPropIncidentContact.primaryAddress.isValidated_Ext', true);
                setIsAddressEdited(false);
                updateIncidentVM(incidentVM);
                setAddressVM(incidentVM.fixPropIncidentContact.primaryAddress);
            } else if(addrssVM?.addressVerifyStatusExt === 'overridden') {
                _.set(incidentVM, 'fixPropIncidentContact.primaryAddress.isOverridden_Ext', true);
                setIsAddressEdited(false);
                updateIncidentVM(incidentVM);
                setAddressVM(incidentVM.fixPropIncidentContact.primaryAddress);
            }
            updateIncidentVM(incidentVM);
            updateWizardData(claimVM);
        }
       
    }, [claimVM, updateWizardData, setDisablity]);

    const updatePolicyAddressVMPropLoc = useCallback((addrssVM) => {
        if (addrssVM) {
            //setAddressPropLocVM(addrssVM);
            _.set(incidentVM.value, 'liabPropDamageLocation', addrssVM.value ? addrssVM.value : addrssVM);
            setDisablityPropLoc(addrssVM);
            if(addrssVM?.addressVerifyStatusExt === 'validated') {
                _.set(incidentVM, 'liabPropDamageLocation.isValidated_Ext', true);
                setIsAddressEditedPropLoc(false);
                updateIncidentVM(incidentVM);
                setAddressPropLocVM(incidentVM.liabPropDamageLocation);
            } else if(addrssVM?.addressVerifyStatusExt === 'overridden') {
                _.set(incidentVM, 'liabPropDamageLocation.isOverridden_Ext', true);
                setIsAddressEditedPropLoc(false);
                updateIncidentVM(incidentVM);
                setAddressPropLocVM(incidentVM.liabPropDamageLocation);
            }
            updateIncidentVM(incidentVM);
            updateWizardData(claimVM);
        }
       
    }, [claimVM, updateWizardData, setDisablityPropLoc]);

    const handleAddressEditing = useCallback((val) => {
        setIsAddressEdited(val);
    });

    const handleAddressEditingPropLoc = useCallback((val) => {
        setIsAddressEditedPropLoc(val);
    });

    const okAction = async () => {
        const incidentSubtreeNotValid = _.get(incidentVM, 'aspects.invalidChildProperties').some(
            (item) => !item.includes('fixPropIncidentContact.primaryAddress') && !item.includes('liabPropDamageLocation')
        );
        
        if (!_.get(incidentVM, 'aspects.valid')
            || !_.get(incidentVM, 'fixPropIncidentContact.aspects.valid')
            || incidentSubtreeNotValid
            || (_.get(incidentVM, 'isAddressRequired.value') && invalidComponent.length)
            || (_.get(incidentVM, 'isLiabLocRequired.value') && invalidComponentPropLoc.length)) {
            setShowErrors(true);
            return;
        }
        if (!_.get(incidentVM, 'isAddressRequired.value')) {
            _.set(incidentVM, 'fixPropIncidentContact.primaryAddress.value', undefined);
        }
        if (!_.get(incidentVM, 'isLiabLocRequired.value')) {
            _.set(incidentVM, 'liabPropDamageLocation.value', undefined);
        }
        const existingIndex = claimVM.incidents?.value?.findIndex((item) => {
            return item.tempID === _.get(incidentVM.value, 'tempID')
            && item.incidentType ===  _.get(incidentVM.value, 'incidentType');
        });
        if (existingIndex > -1) {
            _.set(claimVM, `incidents.value[${existingIndex}]`, incidentVM.value);
        } else {
            claimVM.incidents.value.push(incidentVM.value);
        }
        updateWizardData(claimVM);
        setShowPropDamageForm(false);
        setEditPropDamageForm(false);
    };

    const cancelAction = () => {
        setShowPropDamageForm(false);
        setEditPropDamageForm(false);
    };

    const writeValue = useCallback((value, path) => {
        _.set(incidentVM, path, value);
        if (path === 'isAddressRequired') {
            if (!value) {
                // _.set(incidentVM, 'fixPropIncidentContact.primaryAddress.value', undefined);
                // _.set(addressVM, 'value', undefined);
                setAddressVM(addressVM);
                setShowAddress(false);
                setIsAddressEdited(false);
            } else {
                _.set(primaryAddressVM, 'mustStandardize_Ext.value', true);
                _.set(primaryAddressVM, 'addressVerifyStatusExt.value', 'notvalidated');
                setAddressVM(primaryAddressVM);
                setShowAddress(true);
            }
        }
        if (path === 'isLiabLocRequired') {
            if (!value) {
                // _.set(incidentVM, 'liabPropDamageLocation.value', undefined);
                // _.set(addressPropLocVM, 'value', undefined);
                setAddressPropLocVM(addressPropLocVM);
                setShowAddressDamagedProp(false);
                setIsAddressEditedPropLoc(false);
            } else {
                _.set(propLocAddressVM, 'mustStandardize_Ext.value', true);
                _.set(propLocAddressVM, 'addressVerifyStatusExt.value', 'notvalidated');
                setAddressPropLocVM(propLocAddressVM);
                setShowAddressDamagedProp(true);
            }
        }
        updateIncidentVM(incidentVM);
        updateWizardData(claimVM);
    }, [incidentVM, addressVM, addressPropLocVM]);


    const resolvers = {
        componentMap: {
            addressComponent: TWIAAddressComponent
        },
    };

    const overrideProps = {
        '@field': {
            showOptional: false,
            showRequired: true
        },
        okButton: {
            onClick: okAction,
            disabled: isAddressEdited || isAddressEditedPropLoc
        },
        cancelButtonId: {
            onClick: cancelAction
        },
        mailingAddressComponent: {
            addressVM, updatePolicyAddressVM, country, showErrors, findInvalidComponent, onValidate, authHeader,
            companyType : 'tfpa',
            xPortal,
            ccConstants,
            isStandardizationDisabled,
            onAddressEdit: handleAddressEditing,
            visible: showAddress || !!_.get(incidentVM, 'isAddressRequired.value'),
            isLossLocation: true
        },
        damagePropertyLocationComponent: {
            addressVM: addressPropLocVM, updatePolicyAddressVM: updatePolicyAddressVMPropLoc,
            country: countryPropLoc, showErrors, findInvalidComponent: findInvalidComponentPropLoc,
            onValidate, authHeader,
            companyType : 'tfpa',
            xPortal,
            ccConstants,
            isStandardizationDisabled: isStandardizationDisabledPropLoc,
            onAddressEdit: handleAddressEditingPropLoc,
            visible: showAddressDamagedProp || !!_.get(incidentVM, 'isLiabLocRequired.value'),
            isLossLocation: true
        },
        lossDetailsTitle: {
            visible: appConfig.persona !== 'policyholder' && !isCEAM
        },
        hrDivider1: {
            visible: appConfig.persona !== 'policyholder' && !isCEAM
        }
       
    };

    return (
        <ViewModelForm
            uiProps={metadata.pageContent}
            model={incidentVM}
            onValueChange={writeValue}
            overrideProps={overrideProps}
            classNameMap={styles}
            onValidationChange={onValidate}
            showErrors={showErrors}
            {...resolvers}
        />
    );
};

export default PropertyDamageForm;
